import { render, staticRenderFns } from "./Dettaglio.vue?vue&type=template&id=444b6478&scoped=true&"
import script from "./Dettaglio.vue?vue&type=script&lang=js&"
export * from "./Dettaglio.vue?vue&type=script&lang=js&"
import style0 from "./Dettaglio.vue?vue&type=style&index=0&id=444b6478&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444b6478",
  null
  
)

export default component.exports